import Immutable from 'immutable';
import { combineReducers } from 'redux';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import * as DependentAssetTypes from '../constants/DependentAssetTypes';
import { FETCH_PREVIEW_KEY, FETCH_TEMPLATE, FETCH_THEME_DEPENDENTS } from '../actions/ActionTypes';
import requestStatusFactory from '../reducers/factories/requestStatusFactory';
const EMPTY_LIST = Immutable.List();
function dependentAssetReducerFactory(objectType) {
  return (state = EMPTY_LIST, action) => {
    switch (action.type) {
      case FETCH_THEME_DEPENDENTS:
        {
          const {
            meta,
            requestStatus
          } = action;
          const {
            dependentType
          } = meta;
          if (dependentType !== objectType || requestStatus !== RequestStatusTypes.SUCCEEDED) {
            return state;
          }
          return Immutable.fromJS(action.payload);
        }
      default:
        return state;
    }
  };
}
const dependentAssetRequestStatusReducerFactory = objectType => {
  return (state = RequestStatusTypes.UNINITIALIZED, action) => {
    switch (action.type) {
      case FETCH_THEME_DEPENDENTS:
        {
          const {
            requestStatus
          } = action;
          const {
            dependentType
          } = action.meta;
          return dependentType === objectType ? requestStatus : state;
        }
      default:
        return state;
    }
  };
};
const dependentAssetPaginationReducerFactory = objectType => {
  return (state = {}, action) => {
    switch (action.type) {
      case FETCH_THEME_DEPENDENTS:
        {
          const {
            meta
          } = action;
          if ('total' in meta) {
            const {
              total,
              offset,
              limit,
              dependentType
            } = meta;
            return dependentType === objectType ? {
              total,
              offset,
              limit
            } : state;
          } else return state;
        }
      default:
        return state;
    }
  };
};
const contentPreviewKeys = (state = {}, action) => {
  switch (action.type) {
    case FETCH_PREVIEW_KEY:
      {
        const {
          meta,
          requestStatus
        } = action;
        const {
          pageId
        } = meta;
        if (requestStatus !== RequestStatusTypes.SUCCEEDED) return state;
        return Object.assign({}, state, {
          [pageId]: action.payload.previewKey
        });
      }
    default:
      return state;
  }
};
const templatePreviewKeys = (state = {}, action) => {
  switch (action.type) {
    case FETCH_THEME_DEPENDENTS:
      {
        const {
          meta,
          requestStatus
        } = action;
        const {
          dependentType
        } = meta;
        if (dependentType !== DependentAssetTypes.EXTENSION_RESOURCE || requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return state;
        }
        return action.payload.reduce((previewKeys, template) => {
          const {
            path,
            previewKey
          } = template;
          previewKeys[path] = previewKey;
          return previewKeys;
        }, {});
      }
    case FETCH_TEMPLATE:
      {
        const {
          meta,
          requestStatus
        } = action;
        const {
          templatePath
        } = meta;
        if (requestStatus !== RequestStatusTypes.SUCCEEDED) {
          return state;
        }
        const {
          previewKey
        } = action.payload;
        return Object.assign({}, state, {
          [templatePath]: previewKey
        });
      }
    default:
      return state;
  }
};
function dependentAssetTypeReducerFactory(objectType) {
  return combineReducers({
    objects: dependentAssetReducerFactory(objectType),
    requestStatus: dependentAssetRequestStatusReducerFactory(objectType),
    pagination: dependentAssetPaginationReducerFactory(objectType)
  });
}
export default combineReducers({
  pages: dependentAssetTypeReducerFactory(DependentAssetTypes.PAGE),
  templates: dependentAssetTypeReducerFactory(DependentAssetTypes.EXTENSION_RESOURCE),
  contentPreviewKeys: combineReducers({
    contentPreviewKeys,
    requestStatus: requestStatusFactory(FETCH_PREVIEW_KEY)
  }),
  templatePreviewKeys
});